document.addEventListener("DOMContentLoaded", function(){

    const cartIcon = document.querySelector('.cart-page__header-icon-cart');
  
    if (cartIcon) {
      cartIcon.addEventListener('click', () => {
        location.reload();
      });
    }
  
    const searchBar = () => {
        const barInput = document.querySelector('.td-desktop-search-bar .search__input');
        const searchButton = document.querySelector('.td-desktop-search-bar .search__button');
        const closeButton = document.querySelector('.td-desktop-search-bar .reset__button');
        const nav = document.querySelector('.td-header .header__inline-menu')
        const header = document.querySelector('.td-header header')
        const path = window.location.pathname
        if(path == '/search'){
          if(header){
            header.classList.add('search-section')
          }          
        }
        
        if(barInput) {
            barInput.addEventListener('focus', function() {
                
                this.closest('header').classList.toggle('search-bar-open');
                this.style.width = `${nav.offsetWidth + 182}px`
            })
            barInput.addEventListener('focusout', function() {
                if(this.value) return
                this.closest('header').classList.remove('search-bar-open')
                this.style.width = '174px'
            })
        }
        if(searchButton) {
            searchButton.addEventListener('click', function() {
                this.classList.toggle('btn-search-close')
                if(barInput) {
                    barInput.focus()
                }
            })
        }          
        if(closeButton) {
            closeButton.addEventListener('click', function(){
                if(barInput) {
                    setTimeout(() => {
                        barInput.blur()
                    }, 100)
                    
                }
            })
        }
    }
    const mobileDrawerTopSlider = () => {
        
        const topLinks = Array.from(document.querySelectorAll('.td-mobile-menu-top__link a'));
        const linksPanel = document.querySelector('.td-mobile-menu-top__sublinks')
         
        if(topLinks.length) {
            topLinks.map(link => {
               
                link.addEventListener('click', function(e) {
                    e.preventDefault()
                    const parent = this.parentNode
                    const currentActive = this.closest('ul').querySelector('.td-mobile-menu-top__link--active');                   
                    const idx = this.dataset.idx;
                    const percentage = (idx * -100) + 100;
                    const pixels = (idx * -360) + 360
                    if(currentActive) currentActive.classList.remove('td-mobile-menu-top__link--active');
                    parent.classList.add('td-mobile-menu-top__link--active');
                    if(window.matchMedia('(max-width: 750px)').matches) {                     
                       if(linksPanel) linksPanel.style.transform = `translateX(${percentage}vw)`;
                    }else{
                      if(linksPanel) linksPanel.style.transform = `translateX(${pixels}px)`;
                    }
                   
                      
                })
            })
        }
        
    }
    const accordionAnimation = () => {

        class Accordion {
          constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element
            this.content = el.querySelector('.content-panel');
        
            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
          }
        
          onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
              this.open();
            // Check if the element is being openned or is already open
            } else if (this.isExpanding || this.el.open) {
              this.shrink();
            }
          }
        
          shrink() {
            // Set the element as "being closed"
            this.isClosing = true;
            
            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the height of the summary
            const endHeight = `${this.summary.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
              // Cancel the current animation
              this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
              // Set the keyframes from the startHeight to endHeight
              height: [startHeight, endHeight]
            }, {
              duration: 150,
              easing: 'ease-out'
            });
            
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
          }
        
          open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
          }
        
          expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            // Get the current fixed height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
              // Cancel the current animation
              this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
              // Set the keyframes from the startHeight to endHeight
              height: [startHeight, endHeight]
            }, {
              duration: 150,
              easing: 'ease-out'
            });
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
          }
        
          onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
          }
        }
        
        const details = document.querySelectorAll('.accordion-content');
       
        if(details.length){ 
          details.forEach((el) => {
            new Accordion(el);
          });
        }
   
        
        
    }
    const megaMenu = () => {
      const details = Array.from(document.querySelectorAll("details.mega-menu"))
      if(details.length){
        details.map(elem => {
          elem.addEventListener("toggle", function() {            
            let content = this.querySelector(".mega-menu__content");          
            content.classList.toggle('display-menu')
            content.classList.toggle('fade-in')
          
          });
        })    
        // CLOSE MEGA MENU ON SCROLL 
        const targetElements = Array.from(document.querySelectorAll('.mega-menu__content'))
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 1
        };
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.target.classList.contains('display-menu') && !entry.isIntersecting) {
              const details = entry.target.parentNode;
              window.addEventListener('scroll', () => {
                details.open = false;
              })
             
            }
          });
        }, options);

        targetElements.map(elem => {
          observer.observe(elem);
        })          
          
        }      
    }
    const toggleMobileSearch = () => {
      const searchBtn = document.querySelector('.header__search');
      const mobileHeader = document.querySelector('.td-header');
      const body = document.querySelector('body')
      if(searchBtn) {
        searchBtn.addEventListener('click', () => {
          if(mobileHeader.classList.contains('menu-open')) {
            body.classList.add('open-mobile-nav-search')
          }
        })
      }
     
    }
    toggleMobileSearch()
    searchBar();
    mobileDrawerTopSlider();
    accordionAnimation();
    megaMenu()
});
